import type { DataSeries } from '../../core/types/Beat'

export const buildDataSeries = (data: DataSeries | undefined) => {
  if (!data) {
    return []
  }

  if (data.data) {
    return data.data.map((d) => {
      const item: any = {}

      data.names?.map((name, index) => {
        item[name] = d[index]
      })
      return item
    })
  } else {
    return []
  }
}
